(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var parallaxItems = [];
  var ticking = false;

  function initReveal() {
    var nodes = document.querySelectorAll('[data-lu-reveal]:not(.is-in), [data-lu-mask]:not(.is-in)');
    if (!nodes.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  function collectParallax() {
    if (reduced) return;
    parallaxItems = Array.prototype.slice.call(document.querySelectorAll('[data-lu-parallax]'));
  }

  function applyParallax() {
    var vh = window.innerHeight;
    parallaxItems.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var speed = parseFloat(el.getAttribute('data-lu-parallax')) || 0.12;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (-p * r.height * speed).toFixed(2) + 'px,0)';
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(applyParallax); }
  }

  function initStickyBuy() {
    var bar = document.querySelector('[data-lu-sticky]');
    var anchor = document.querySelector('[data-lu-add]');
    if (!bar || !anchor || bar.dataset.luBound) return;
    bar.dataset.luBound = '1';
    var updateSticky = function () {
      bar.classList.toggle('is-on', anchor.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  }

  function boot() {
    initReveal(); collectParallax(); applyParallax(); initStickyBuy();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { collectParallax(); onScroll(); }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () {
    initReveal(); collectParallax(); applyParallax(); initStickyBuy();
  });
})();
